
import Vue from 'vue'
import BayFull from '@/view/pages/vesselProfile/components/BayFull.vue'
import { FETCH_VESSEL_PROFILE } from '@/core/services/store/vesselProfile.module'
import ShipSideView from '@/view/pages/vesselProfile/components/ShipSideView.vue'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import AppButton from "@/components/AppButton.vue"
import BayFullHatchCovers from '@/view/pages/vesselProfile/components/HatchCovers/BayFullHatchCovers.vue'
import { SET_SELECTED_HATCH_INDEX, DELETE_VESSEL_HATCH, ADD_VESSEL_HATCH } from '@/core/services/store/vesselProfile.module'

interface BayData {
    name: string
    containers: unknown[] // Adjust the type of containers
}
export enum VesselHatchType {
    Hatch = 1,
    Bridge = 2,
    Engine = 3,
    Crane = 4,
    Blank = 5,
    Funnel = 6
}
interface Section {
    id: string
    type: VesselHatchType
    hatchType: VesselHatchType
    hasBayFore: boolean
    bayFore: number
    bayAfter: number
    bay40: number
    hasBay40: boolean
    hasBayAfter: boolean
    underDeck: {
        rowCount: number
    }
    onDeck: {
        rowCount: number
    },
    position: number
}
export default Vue.extend({
    components: {
        BayFull,
        ShipComponent: ShipSideView,
        AppButton, BayFullHatchCovers
    },
    inject: ["showErrors", "showSuccess", "showWarning", "isStandalone"],
    data() {
        return {
            select: { state: 'Florida', abbr: 'FL' },
            selectedAction: "",
            vesselHatchOptions: [
                { state: "Hatch", abbr: VesselHatchType.Hatch },
                { state: "Bridge", abbr: VesselHatchType.Bridge },
                { state: "Engine", abbr: VesselHatchType.Engine },
                { state: "Crane", abbr: VesselHatchType.Crane },
                { state: "Blank", abbr: VesselHatchType.Blank },
                { state: "Funnel", abbr: VesselHatchType.Funnel }
            ],
            loadingMessage: 'Please wait ...',
            loading: false,
            selectedContainerType: 'standard',
            mirrorMode: false,
            bayData: [
                {
                    name: 'Bay 01',
                    containers: []
                }
            ] as BayData[],
        }
    },
    computed: {
        ...mapGetters({
            vesselProfile: 'getVesselProfile',
            selectedHatchId: 'getSelectedVesselProfile',
            selectedHatchIndex: 'getSelectedHatchIndex',
            selectedHatchData: 'getSelectedHatchData',
            showHatchCover: 'getShowHatchCover'
        }),
        vesselProfileName() {
            return this.$store.state.vesselProfile.vesselProfile.vesselProfileName
        },
        selectedHatchType: {
            get() {
                return this.selectedHatchData.vesselHatchType;
            },
            set(value: { state: string; abbr: number }) {
                this.setSelectedHatchData({ vesselHatchType: value.abbr })
            }
        },
        hasBayFore: {
            get() {
                return this.selectedHatchData.hasBayFore
            },
            set(value) {
                this.setSelectedHatchData({ hasBayFore: value })
            }
        },
        hasBay40: {
            get() {
                return this.selectedHatchData.hasBay40
            },
            set(value) {
                this.setSelectedHatchData({ hasBay40: value })
            }
        },
        hasBayAfter: {
            get() {
                return this.selectedHatchData.hasBayAfter
            },
            set(value) {
                this.setSelectedHatchData({ hasBayAfter: value })
            }
        },
        bay40Value: {
            get() {
                return String(this.selectedHatchData.bay40).padStart(2, '0')
            },
            set(value) {
                this.setSelectedHatchData({ bay40: +value })
            }
        },
        bayAfterValue: {
            get() {
                return String(this.selectedHatchData.bayAfter).padStart(2, '0')
            },
            set(value) {
                this.setSelectedHatchData({ bayAfter: +value })
            }
        }, bayForeValue: {
            get() {
                return String(this.selectedHatchData.bayFore).padStart(2, '0')
            },
            set(value) {
                this.setSelectedHatchData({ bayFore: +value })
            }
        },
    },
    methods: {
        ...mapActions({
            setSelectedHatchData: 'setSelectedHatchData',
            fetchVesselProfile: FETCH_VESSEL_PROFILE,
            postVesselProfile: 'postVesselProfile',
            setIsLoading: 'setIsLoading'
        }),
        handleAction(direction) {
            this.$store.dispatch({ type: ADD_VESSEL_HATCH, data: { position: direction, actionType: this.selectedAction } })
        },
        deleteHatch() {
            console.log("Deleting vessel hatch...");
            // تابع حذف را اینجا بنویسید
        },

        updateHatchType(value) {
            //زمانی که نوع به غیر دریچه باشد مقادیر bay ریس میشه محاسبات شماره گذاری bay مجدد برای تمام دریچه ها محاسبه میشه
            if (value.state != "Hatch") {
                this.hasBayFore = false
                this.hasBay40 = false
                this.hasBayAfter = false
            } else {
                this.hasBayFore = true
                this.hasBay40 = true
                this.hasBayAfter = true
                // زمانی نوع به عنوان دریچه انتخاب شد پارامتر مورد نیاز برای نمایش پروفایل مربوط به دریچه اینجا محاسبه و واکشی میشه
                var selectedHatch = this.$store.state.vesselProfile.vesselProfile.vesselProfileHatches[this.selectedHatchIndex];

                const maxholdTiers = this.$store.state.vesselProfile.vesselProfile.maxHoldTiers;
                const maxholdRows = this.$store.state.vesselProfile.vesselProfile.maxHoldRows;

                const cellTemplate = { existed: true, isReefer: false, is45Foot: false };

                ["hold40", "holdAfter", "holdFore"].forEach(holdType => {
                    selectedHatch[holdType].cols = maxholdRows;
                    selectedHatch[holdType].rows = maxholdTiers;
                    selectedHatch[holdType].cells = Array(maxholdTiers * maxholdRows).fill(cellTemplate);
                    selectedHatch[holdType].vesselProfileHatchCovers = []
                });

                const maxDeckTiers = this.$store.state.vesselProfile.vesselProfile.maxDeckTiers;
                const maxDeckRows = this.$store.state.vesselProfile.vesselProfile.maxDeckRows;
                ["onDeck40", "onDeckAfter", "onDeckFore"].forEach(deckType => {
                    selectedHatch[deckType].cols = maxDeckRows;
                    selectedHatch[deckType].rows = maxDeckTiers;
                    selectedHatch[deckType].cells = Array(maxDeckRows * maxDeckTiers).fill(cellTemplate);
                    selectedHatch[deckType].vesselProfileHatchCovers = []
                });

                const CellsCount = Math.max(maxholdRows, maxDeckRows) * 4;
                selectedHatch.cellsCount = CellsCount
            }
            this.$store.dispatch({ type: 'setSelectedHatchIndex', index: this.selectedHatchIndex })
        },
        getIsLoading() {
            return this.$store.state.vesselProfile.isLoading
        },
        ...mapMutations({
        }),
        onSave() {
            /* this.setSelectedHatchData({
                vesselProfileHatchCovers: [{
                    coverName: "string",
                    startCell: 0,
                    endCell: 0
                },{
                    coverName: "string",
                    startCell: 0,
                    endCell: 0
                }]
            }) */

            this.postVesselProfile()
                .then((data: any) => {
                    this.showErrors(data.message)
                })
            this.loading = true
        },
        onRefresh() {
            this.fetchVesselProfile(this.$route.params.id || 1)
                .catch((error: any) => this.showSuccess(error.message))
                .finally(() => {
                    this.loading = false
                })
        },
        selectContainerType(type: string) {
            this.selectedContainerType = type
        },
        onBayNumberChange(event: Event) {
            const target = event.target as HTMLInputElement
            this.setSelectedHatchData({ [target.name]: target.value })
        },
        onBayForeExistChange(event: Event) {
            const target = event.target as HTMLInputElement
            this.setSelectedHatchData({ hasBayFore: this.hasBayFore })
        },
        onBay40FootExistChange(event: Event) {
            const target = event.target as HTMLInputElement
            this.setSelectedHatchData({ [target.name]: target.checked })
        },
        onBayAfterExistChange(event: Event) {
            const target = event.target as HTMLInputElement
            this.setSelectedHatchData({ [target.name]: target.checked })
        }
    },
    mounted() {
        this.fetchVesselProfile(this.$route.params.id || 1)
            .catch((error: any) => console.error(error.message))
    }
})
